import { Row, Col } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";

import { AnchorButton } from "../../Shared/Common/Anchor/Button";
import Heading from "../../Shared/Common/Heading";
import SimpleImage from "../../Shared/Media/SimpleImage";

import AlumniRecruitmentIntroImage from "../../../assets/images/nml/training_development.webp";

type AlumniRegisterBoxProps = {
  href: string;
};

const REGISTER_LINK =
  "https://retiree.alumy.jp/enterprises/68ae9330d96d4ce78d053ac985ef9b98/retirees/invite?utm_source=hr_flow&utm_medium=flyer&utm_campaign=";

const AlumniRegisterBox = ({ href }: AlumniRegisterBoxProps) => (
  <div className="alumni-register-box">
    <Heading type="section-sub-heading">
      <FormattedMessage id="page.nml.alumni_recruitment.intro.alumni_register.title" />
    </Heading>

    <p className="my-3">
      <FormattedMessage id="page.nml.alumni_recruitment.intro.alumni_register.description" />
    </p>

    <AnchorButton
      variant={"secondary"}
      external={true}
      ewhite={true}
      href={href}
    >
      <FormattedMessage id="page.nml.alumni_recruitment.intro.alumni_register.button" />
    </AnchorButton>
  </div>
);

const AlumniRecruitmentIntro = () => {
  const { locale } = useIntl();

  const isJapanese = locale === "ja";

  return (
    <div className="alumni-intro">
      <h2>
        <FormattedMessage id="page.nml.alumni_recruitment.intro.title" />
      </h2>
      <Row
        className={isJapanese ? "jp-alumni-intro-row" : "align-items-center"}
      >
        {/* Left Content */}
        <Col
          lg={6}
          md={12}
          xs={12}
          className={`alumni-intro-section-content ${isJapanese ? "jp-alumni-intro-section-content" : ""}`}
        >
          <div className={isJapanese ? "alumni-intro-description" : ""}>
            <p>
              <FormattedMessage id="page.nml.alumni_recruitment.intro.description" />
            </p>
          </div>

          {/* Japanese Only Section */}
          {isJapanese && (
            <div className="only-desktop">
              <AlumniRegisterBox href={REGISTER_LINK} />
            </div>
          )}
        </Col>

        {/* Right Image */}
        <Col lg={6} md={12} xs={12} className="alumni-intro-image-column">
          <SimpleImage
            src={AlumniRecruitmentIntroImage}
            className="alumni-intro-image"
          />
        </Col>
      </Row>

      {/* Mobile Button */}
      {isJapanese && (
        <div className="only-mobile">
          <AlumniRegisterBox href={REGISTER_LINK} />
        </div>
      )}
    </div>
  );
};

export default AlumniRecruitmentIntro;
